<template>
    <div class="real-name-box">
		<div class="page-btns-box">
		    <el-button
		        type="primary"		        
		        @click="changeVisible = true"
		        v-if="$utils.have('/userInfo/rep_tel')"
		        size="small"
		        >开始对调</el-button>
		</div>
		<div class="page-list-box">
            <el-table
                :data="dataList"		        
                border
                style="width: 100%"
                v-loading="listLoading"
                size="small"
                stripe
            >
                
                <el-table-column label="对调时间" prop="modifyTime" width="300"></el-table-column>
                <el-table-column label="对调记录" prop="desc"></el-table-column>		       
            </el-table>
		</div>
		<div v-if="data" class="page-pagination-box">
		    <el-pagination
		        background
		        @size-change="handleSizeChange"
		        @current-change="getDataList"
		        :current-page.sync="params.pageNo"
		        :page-sizes="$pageSizes"
		        :page-size.sync="params.pageSize"
		        layout="total, sizes, prev, pager, next"
		        :total="data.totalCount || 0">
		    </el-pagination>
		</div>
        <Change :changeVisible.sync="changeVisible" @onUpdate="getDataList" /> 
    </div>
</template>
<script>
	import Change from './components/change.vue';
export default {
    data() {
        return {
            dataList: [],
			params:{
			    pageNo:1,
			    pageSize:this.$pageSizes[0]
			},
			listLoading: false,
			data: null,
			changeVisible: false,
        };
    },
    components: {
      Change
    },
    computed: {
        
        
    },
    mounted(){
        this.getDataList();
    },
    methods: {
        //获取列表
        getDataList() {
            this.listLoading = true;
            this.$request({
                url: "/userInfo/rep_list",
                method: "POST",
                data: this.params
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1 && result) {
						
                       this.data = result;
                       this.dataList = result.result || [];
						
                    } else {
                        this.$message.error(msg || "请求失败");
                    }
                })
                .finally(() => {
                    this.listLoading = false;
                });
        },		
		
        //选择pageSize
        handleSizeChange(e) {
            this.params.pageNo = 1;
            this.params.pageSize = e;
            this.getDataList();
        },
		change(){
			this.changeVisible = true
		}
		
    }
};
</script>
